import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Gama } from '../../models/Gama';
import { FirebaseService } from '../auth/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class GamaService {

  constructor(private http: HttpClient,
              private firebaseService: FirebaseService){}

  /**
   * Creates a new Gama
   */
  createGama(gama: Partial<Gama>){
    return this.http.post<Gama>(`${environment.URL_API}/api/gamas`, gama, {headers: this.firebaseService.authHeader})
  }

  /**
   * Updates a Gama
   */
  updateGama(gama: Partial<Gama>){
    return this.http.patch<Gama>(`${environment.URL_API}/api/gamas/update`, gama, {headers: this.firebaseService.authHeader})
  }

  /**
   * Deletes a Gama by its id
   */
  deleteGamaById(id: string){
    return this.http.delete(`${environment.URL_API}/api/gamas/${id}`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Gets all Gamas
   */
  getAllGamas(){
    return this.http.get<Gama[]>(`${environment.URL_API}/api/gamas`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Gets a Gama by its id
   */
  getGamaById(id: string){
    return this.http.get<Gama>(`${environment.URL_API}/api/gamas/${id}`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Get Gama by Order Number and Number
   */
  getGamaByOrderNumberAndNumber(order_number: string, gama_number: string){
    return this.http.get<Gama>(`${environment.URL_API}/api/gamas/order/${order_number}/gama/${gama_number}`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Get Gama with actions by its id
   */
  getGamaWithActions(id: string){
    return this.http.get<Gama>(`${environment.URL_API}/api/gamas/actions/${id}`, {headers: this.firebaseService.authHeader})
  }

  /**
   * Gets Gamas by their order_id
   */
  getGamasByOrderId(order_id: string){
    return this.http.get<Gama[]>(`${environment.URL_API}/api/gamas/order/${order_id}`, {headers: this.firebaseService.authHeader})
  }
}